import { useDispatch } from 'react-redux'
import { authSlice, ForgotPasswordStep } from '../../../../authSlice'
import { Button } from '@wellesley/ui'
import { FC } from 'react'
import useNavigateBack from 'hooks/useNavigateBack'

type BackButtonProps = {
  open?: ForgotPasswordStep | 'back'
  className?: string
}

export const BackButton: FC<BackButtonProps> = ({
  open = 'back',
  className,
}) => {
  const dispatch = useDispatch()
  const { setForgotPasswordStep } = authSlice.actions
  const navigateBack = useNavigateBack()

  const handleClick = () => {
    if (open === 'back') {
      navigateBack()
    } else {
      dispatch(setForgotPasswordStep(open))
    }
  }

  return (
    <Button
      variant="secondary"
      size="m"
      onClick={handleClick}
      className={className}
    >
      Back
    </Button>
  )
}
